/*global jQuery, $ */

import Nanobar from 'nanobar';

let $searchForm;
let refreshResultTimer;
let refreshPrefectureTimer;

let refreshIndicator = new Nanobar({
  classname: 'loading-indicator',
});

function updateLocalityShowButton() {
  let $localities = $('#search-form').find('input[name="locality[]"]:checked');
  let text;

  if ($localities.length === 0) {
    text = '市区町村を選択';
  } else {
    text = $localities.closest('.checkbox')
      .find('.name')
      .map(function () {
        return $(this).text();
      })
      .toArray()
      .join('、');
  }

  $('#locality-dialog-show-button').text(text);
}

function currentUrl() {
  let search = $('#search-form').serialize();
  let url = `${window.location.pathname}?${search}`;

  return url;
}

function requestRefreshResult() {
  if (refreshResultTimer) {
    clearTimeout(refreshResultTimer);
  }

  refreshResultTimer = setTimeout(refreshResult, 250);
}

function refreshResult() {
  refreshIndicator.go(60);

  let url = currentUrl();

  // $('main').load(url + ' main > *', function () {
  //   refreshResultTimer = null;
  //   refreshIndicator.go(100);
  // });
  //
  // window.history.pushState(null, null, url);

  window.location = url;
}

function requestRefreshPrefecture() {
  if (refreshPrefectureTimer) {
    clearTimeout(refreshPrefectureTimer);
  }

  refreshPrefectureTimer = setTimeout(refreshPrefecture, 0);
}

function moveToSearchResult(prefectureId, regionId, localityIds) {
  refreshIndicator.go(60);

  if (prefectureId) {
    $searchForm.find('select[name="prefecture_id"]').val([prefectureId]);
  }

  if (regionId) {
    $searchForm.append($('<input type="hidden" name="region_id" />').val(regionId));
  }

  localityIds = localityIds || [];

  localityIds.map(function (localityId) {
    $searchForm.append($('<input type="hidden" name="locality[]" />').val(localityId));
  });

  $searchForm.submit();
}

$(function () {
  $searchForm = $('#search-form')
    .on('change', 'select[name="area_id"]', function () {
      $searchForm
        .find('select[name="prefecture_id"]').val(['']).end()
        .find('select[name="region_id"]').val(['']).end()
        .find('input[name="locality_id[]"]').prop('checked', false);

      moveToSearchResult();
    })
    .on('change', 'select[name="prefecture_id"]', function () {
      let currentArea = $searchForm.find('select[name="area_id"]').val();
      let newArea = this.options[this.selectedIndex].getAttribute('data-area');

      if (currentArea !== newArea) {
        $searchForm.find('select[name="area_id"]').val(['']);
      }

      $searchForm.find('input[name="locality[]"]').prop('checked', false);

      moveToSearchResult();
    })
    .on('change', 'select[name="region_id"]', function () {
      $searchForm.find('input[name="locality[]"]').prop('checked', false);

      moveToSearchResult();
    })
    .on('change', 'input[name="locality[]"]', function () {
      $searchForm.find('select[name="region_id"]').val(['']);

      moveToSearchResult();
    });

  $(document)
    .on('click', '[data-prefecture]', function (e) {
      e.preventDefault();

      var prefectureId = e.currentTarget.getAttribute('data-prefecture');

      moveToSearchResult(prefectureId, null, null);
    })
    .on('click', '[data-region]', function (e) {
      e.preventDefault();

      var regionId = e.currentTarget.getAttribute('data-region');

      moveToSearchResult(null, regionId, null);
    })
    .on('click', '[data-locality]', function (e) {
      e.preventDefault();

      var localityIds = [e.currentTarget.getAttribute('data-locality')];

      moveToSearchResult(null, null, localityIds);
    });

  $(document)
    .on('click', '#search_change, #area_change', function (e) {
      e.preventDefault();

      $("#search_panel_modal").show();
      $("#search_modal").show();
    })
    .on('click', '#search_modal', function (e) {
      if (e.currentTarget !== e.target) {
        return;
      }

      e.preventDefault();

      $("#search_panel_modal").hide();
      $("#search_modal").hide();
    });
});
